module.exports = __webpack_public_path__ + "static/media/LA.445a9170.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/LA.svg
// module id = 2193
// module chunks = 7